import styles from "./contact.module.css";

const Contact = () => {
  return (
    <div id="contact" className={styles.main}>
      <h1 className="text_theme">
        Get in <span className="text-blue">Touch</span>
      </h1>
      <ul className={styles.contactList}>
        <li>
          <a
            href="https://github.com/ankitkumar3443"
            aria-label="GitHub"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            <i className="fab fa-github"></i>
          </a>
        </li>
        <li>
          <a
            href="mailto:ankitKumar3443@gmail.com"
            aria-label="GitHub"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            <i className="fa fa-envelope"></i>
          </a>
        </li>
        <li>
          <a
            href="https://www.linkedin.com/in/ankit-kumar-92113b201/"
            aria-label="GitHub"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            <i className="fab fa-linkedin" aria-hidden="true"></i>
          </a>
        </li>
        <li>
          <a
            href="https://twitter.com/ankitkumar3443"
            aria-label="GitHub"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            <i class="fab fa-twitter-square" aria-hidden="true"></i>
          </a>
        </li>
        <li>
          <a
            href="https://wa.me/917277350695"
            aria-label="WhatsApp"
            target="_blank"
            rel="noreferrer"
          >
            {" "}
            <i className="fab fa-whatsapp"></i>
          </a>

          
        </li>
      </ul>
    </div>
  );
};

export default Contact;
